//export const baseUrl = 'http://localhost:5000/api';
export const baseUrl = 'https://newswebsiteapi.ahmohazzab.com/api';